import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import FuelReportInfo from '../../containers/DeviceMap/fuel-report/FuelReportInfo';

am4core.useTheme(am4themes_animated);

function FuelConsumptionBarLineChart({ data: docs, assetData, selectedGroup, loading, ...props }) {
    const [data, setData] = useState([]);
    const [header, setHeader] = useState('--');

    useEffect(() => {
        setData(docs)
    }, [docs]);

    useLayoutEffect(() => {
        if (selectedGroup && assetData) {
            const title = selectedGroup === 'w' ? 'Weekly' : selectedGroup === 'm' ? 'Monthwise' : selectedGroup === 'y' ? 'Yearwise' : 'Daywise';
            setHeader(`${title} fuel consumption for ${assetData.assetCode}`)
        }
    }, [selectedGroup, assetData]);

    const chart = useRef(null);

    useLayoutEffect(() => {
        if (!loading && data && data.length) {

            let totalFuel = 0;
            data.forEach(d => {
                totalFuel += Number(d.fuel_consumed)
            })


            // am4core.addLicense("ch-custom-attribution");
            let x = am4core.create("fuelConsumed", am4charts.XYChart);

            let title = x.titles.create();
            title.text = header;
            title.fontSize = 15;
            title.marginBottom = 18;

            // Export
            x.exporting.menu = new am4core.ExportMenu();
            x.exporting.filePrefix = "fuel_consume_data_" + new Date().getTime();

            x.paddingRight = 20;

            let dateAxis = x.xAxes.push(new am4charts.CategoryAxis());
            // dateAxis.dataFields.category = "date";
            dateAxis.dataFields.category = 'date';
            // dateAxis.title.text = "Date"
            dateAxis.title.text = selectedGroup === 'm' ? 'Month' : selectedGroup === 'w' ? 'Week' : selectedGroup === 'y' ? 'Year' : 'Date Range';
            // dateAxis.title.rotation = -90;
            // dateAxis.renderer.minGridDistance = 10;
            // dateAxis.title.fill = am4core.color("#ff0000");
            // dateAxis.title.align = "left"; // Align the title to the left
            // dateAxis.title.valign = "top"; // Vertically align the title to the top
            // dateAxis.title.dy = -30; // Adjust the y position
            // dateAxis.renderer.labels.template.rotation = -90;

            let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = 'Fuel Consumed (ltr)'

            let columnSeries = x.series.push(new am4charts.ColumnSeries());
            columnSeries.name = "Fuel Consumed";
            columnSeries.dataFields.valueY = "fuel_consumed";
            columnSeries.dataFields.categoryX = "date";
            // columnSeries.title.text = 'Fuel Consumed'

            columnSeries.columns.template.tooltipText = "[#fff font-size: 12px]{name} in {dateX}:\n[/][#fff font-size: 15px]{valueY}[/] [#fff]{additional}[/]"
            columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
            columnSeries.columns.template.propertyFields.stroke = "stroke";

            // columnSeries.columns.template.width = 20;
            // columnSeries.columns.template.column.cornerRadiusTopLeft = 20;
            // columnSeries.columns.template.column.cornerRadiusTopRight = 20;

            columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
            columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
            columnSeries.tooltip.label.textAlign = "middle";
            columnSeries.columns.template.strokeOpacity = 0;
            // columnSeries.columns.template.fill = am4core.color("#104547"); // Change color of all columns
            // columnSeries.columns.template.stroke = am4core.color("#000000"); // Optional: add border color to columns

            // Apply random color from predefined color set
            columnSeries.columns.template.adapter.add("fill", function (fill, target) {
                return x.colors.getIndex(target.dataItem.index);
            });


            function adjustColumnWidth() {
                let totalColumns = data.length;
                let totalWidth = dateAxis.pixelWidth;

                // Adjust the width here. This is an example formula.
                // Adjust the formula as per your requirement.
                let columnWidth = Math.min(20, totalWidth / (totalColumns * 2));

                columnSeries.columns.template.width = am4core.percent(columnWidth);
                columnSeries.columns.template.column.cornerRadiusTopLeft = am4core.percent(columnWidth * 2);
                columnSeries.columns.template.column.cornerRadiusTopRight = am4core.percent(columnWidth * 2);

            }
            columnSeries.hidden = true;

            // Adjust column width initially and on data change
            adjustColumnWidth();
            x.events.on("datavalidated", adjustColumnWidth);

            let lineSeries = x.series.push(new am4charts.LineSeries());
            lineSeries.name = "Fuel Consumed";
            lineSeries.dataFields.valueY = "fuel_consumed";
            lineSeries.dataFields.categoryX = "date";

            // lineSeries.stroke = am4core.color("#fdd400");
            lineSeries.strokeWidth = 2;
            lineSeries.propertyFields.strokeDasharray = "lineDash";
            lineSeries.tooltip.label.textAlign = "middle";
            lineSeries.legendSettings.labelText = `Fuel Consumed. (Total: ${totalFuel.toFixed(2)} ltrs.)`;



            let bullet = lineSeries.bullets.push(new am4charts.Bullet());
            bullet.fill = am4core.color("#fff"); // tooltips grab fill from parent by default
            bullet.tooltipText = "[#333 font-size: 11px]{name} in {categoryX}:\n[/][#333 font-size: 15px]{valueY} ltr[/] [#333]{additional}[/]"

            let circle = bullet.createChild(am4core.Circle);
            circle.radius = 2;
            circle.fill = am4core.color("#fff");
            circle.strokeWidth = 1;

            // let lineSeries2 = x.series.push(new am4charts.LineSeries());
            // lineSeries2.name = "Fuel Consumed Rate";
            // lineSeries2.dataFields.valueY = "consumption_rate";
            // lineSeries2.dataFields.dateX = "date";

            // // lineSeries2.stroke = am4core.color("#fdd400");
            // lineSeries2.strokeWidth = 1;
            // lineSeries2.propertyFields.strokeDasharray = "lineDash";
            // lineSeries2.tooltip.label.textAlign = "middle";



            // let bullet2 = lineSeries2.bullets.push(new am4charts.Bullet());
            // bullet2.fill = am4core.color("#fff"); // tooltips grab fill from parent by default
            // // bullet2.tooltipText = "[#fff font-size: 15px]{name} in {dateX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"

            // let circle2 = bullet2.createChild(am4core.Circle);
            // circle2.radius = 3;
            // circle2.fill = am4core.color("#fff");
            // circle2.strokeWidth = 1;

            x.legend = new am4charts.Legend();

            // Add cursor
            x.cursor = new am4charts.XYCursor();
            x.cursor.fullWidthLineX = true;
            x.cursor.xAxis = dateAxis;
            x.cursor.lineX.strokeOpacity = 0;
            x.cursor.lineX.fill = am4core.color("#000");
            x.cursor.lineX.fillOpacity = 0.1;

            // Add scrollbar
            if (data && data.length > 25) {
                let scrollbarX = new am4charts.XYChartScrollbar();
                scrollbarX.series.push(columnSeries);
                // scrollbarX.marginBottom = 50;
                x.scrollbarX = scrollbarX;
            }
            x.cursor = new am4charts.XYCursor();
            x.data = data;

            chart.current = x;

            return () => {
                if (x)
                    x.dispose();
            };
        }
    }, [data, header]);

    useLayoutEffect(() => {
        if (chart && chart.current)
            chart.current.paddingRight = props.paddingRight;
    }, [props.paddingRight]);

    return <>{loading ? <div style={{ width: "100%", height: "500px", display: 'flex', alignItems: 'center', justifyContent: 'center' }} >Loading ...</div> : <div id="fuelConsumed" style={{ width: "100%", height: "500px" }} />}</>

}

export default FuelConsumptionBarLineChart;